import React from 'react'

type DrawerContextType = {
  withCloseButton: boolean
}

export const DrawerContext = React.createContext<DrawerContextType>({
  withCloseButton: false,
})
